import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import styled from '@emotion/styled';
import { N20 } from '@atlaskit/theme/colors';
import { fontSize, gridSize } from '@atlaskit/theme/constants';
import { headingSizes } from '@atlaskit/theme/typography';
import { FormGrid } from '../../../common/ui/FormGrid/styled';
export var LoadingForm = styled(FormGrid)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  transition-property: opacity;\n  transition-duration: 300ms;\n  background-color: white;\n  text-align: left;\n\n  opacity: ", ";\n  z-index: 1;\n  pointer-events: ", ";\n"])), function (_ref) {
  var visible = _ref.visible;
  return visible ? 1 : 0;
}, function (_ref2) {
  var visible = _ref2.visible;
  return visible ? 'auto' : 'none';
});
var Skeleton = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-block;\n  background-color: ", ";\n  font-size: ", "em;\n  border-radius: 3px;\n"])), N20, headingSizes.h200.size / fontSize());
export var LabelSkeleton = styled(Skeleton)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 98px;\n  margin-bottom: ", "px;\n"])), gridSize() / 2);
export var FieldSkeleton = styled(Skeleton)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: ", "px 0;\n  margin: 0;\n  box-sizing: border-box;\n  border: 2px solid transparent;\n\n  line-height: 1.2em;\n"])), gridSize() + 2);